(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const setActiveNavigation = () => {
    const path = window.location.pathname;
    let active = 'home';
    if (path.startsWith('/collections')) active = 'collections';
    if (path.startsWith('/account')) active = 'account';
    if (path.startsWith('/cart')) active = 'cart';
    document.querySelectorAll('[data-bldb-nav]').forEach((item) => {
      if (item.dataset.bldbNav === active) item.setAttribute('aria-current', 'page');
      else item.removeAttribute('aria-current');
    });
  };

  const openExistingControl = (selector) => {
    const control = document.querySelector(selector);
    if (control instanceof HTMLElement) {
      control.click();
      return true;
    }
    return false;
  };

  document.addEventListener('click', (event) => {
    if (!mobile.matches) return;
    const searchTrigger = event.target.closest('[data-bldb-search-trigger]');
    if (searchTrigger) {
      event.preventDefault();
      openExistingControl('.header__search summary');
      return;
    }

    const cartTrigger = event.target.closest('[data-bldb-cart-trigger]');
    if (cartTrigger && document.querySelector('cart-drawer')) {
      event.preventDefault();
      openExistingControl('#cart-icon-bubble');
    }
  });

  document.addEventListener('shopify:section:load', setActiveNavigation);
  setActiveNavigation();
})();
